import React from 'react';
import classNames from 'classnames';
import "./Spacer.css";
export default function Spacer(props) {
  var size = props.size ? props.size : 'md';
  var classes = classNames('Spacer', "Spacer--" + size);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  });
}
//# sourceMappingURL=Spacer.js.map